import * as React from "react";
import {Buttons} from "../../../../components/buttons/Buttons";
import {HaccpTableCell} from "./HaccpTableCell";

import "./HaccpTableRow.scss";
import {Button} from "@vebox/etui-core";

export interface Record {
    configurationId: number;
    date: string;
    defrostOn: boolean;
    currentMax: number;
    currentMin: number;
    lo?: number;
    hi?: number;
    max: number;
    maxBgColor: string;
    maxTxColor: string;
    min: number;
    minBgColor: string;
    minTxColor: string;
    mean: number;
    sd: number;
    switchOn: boolean;
    color?: string;
    textColor?: string;
    thresholdsChanged: boolean;
    texts: {
        max: string,
        avg: string,
        min: string,
    };
}

export class HaccpTableRow {
    public static renderNotConfig = (
        name,
        showExtremes: boolean,
        onAdd?,
        rowKey?,
        indent?,
        hasHaccpConfigs?: boolean,
    ) => {
        return (
            <tr className={"HaccpTableRow"} key={rowKey}>
                <td className={"sticky-td"} colSpan={0} style={(indent) ? {textIndent: "1em"} : {textIndent: "0em"}}>
                    <div className={"cell-content-wrapper"}>
                        <div className={"vertical-align"}>
                            <p className={"diagnostics-name"}>
                                {name}
                            </p>

                            <div className="actions">
                                <div style={{display: "inline-block", marginRight: "10px"}}>
                                    <Buttons.ComponentButton
                                        key={12}
                                        code={"edit"}
                                        frontComponent={
                                            <div className={"iconAligner"}>
                                                <span className="material-icons-outlined">add</span>
                                            </div>
                                        }
                                        selected={false}
                                        onClick={onAdd}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td
                    className="lo-col"
                    style={{
                        height: "50px",
                        borderRight: hasHaccpConfigs ? "none" : "2px solid white",
                    }}
                >
                    <div
                        className="cell-content-wrapper"
                        style={{
                            borderRight: "none",
                        }}
                    >
                        <div className="vertical-align"/>
                    </div>
                </td>
                <td className="hi-col" style={{height: null}}>
                    <div
                        className="cell-content-wrapper"
                        style={{
                            borderRight: (showExtremes)
                                ? (hasHaccpConfigs ? "2px solid white" : null)
                                : "2px solid gainsboro",
                            boxShadow: (showExtremes) ? null : "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                        }}
                    >
                        <div className="vertical-align"/>
                    </div>
                </td>
                {
                    !hasHaccpConfigs ?
                        (<td className="" style={{height: "50px"}}>
                            <div className="cell-content-wrapper" style={{}}>
                                <div className="vertical-align"/>
                            </div>
                        </td>)
                        : null
                }
                {showExtremes
                    ? (
                        <td className={"def-col"} style={{height: "50px"}}>
                            <div
                                className={"cell-content-wrapper"}
                                style={
                                    {
                                        borderRight: "2px solid gainsboro",
                                        boxShadow: "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                                    }
                                }
                            />
                        </td>
                    ) : null}
            </tr>

        );
    }

    public static renderConfig = ({
                                      probeName,
                                      content,
                                  }
        ,
                                  lo,
                                  hi,
                                  showExtremes,
                                  {
                                      max, avg, min,
                                  },
                                  records: Record[],
                                  texts:
                                      {
                                          lo: string,
                                          hi: string,
                                      },
                                  onEdit?,
                                  onExport?,
                                  onDelete?,
                                  rowKey?,
                                  indent?,
    ) => {

        return (
            <tr className={"HaccpTableRow"} key={rowKey}>
                <td className={"sticky-td"} style={(indent) ? {textIndent: "1em"} : {textIndent: "0em"}}>
                    <div className={"cell-content-wrapper"}>
                        <div className={"vertical-align"}>
                            <div className={"diagnostics-name"}>
                                <p>
                                    {probeName}
                                </p>
                                <p>
                                    ({content})
                                </p>
                            </div>
                            <div className={"actions"}>
                                <div
                                    style={{
                                        display: "inline-flex",
                                        marginRight: "10px",
                                    }}
                                >
                                    <Buttons.ComponentButton
                                        key={12}
                                        code={"edit"}
                                        frontComponent={<div className={"iconAligner"}><span className="material-icons-outlined icon">edit</span></div>}
                                        selected={false}
                                        onClick={onEdit}
                                        styles={{
                                            root: {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }
                                        }}
                                    />
                                    <Buttons.ComponentButton
                                        key={13}
                                        code={"delete"}
                                        frontComponent={<div className={"iconAligner"}><span className="material-icons-outlined icon">delete</span></div>}
                                        selected={false}
                                        onClick={onDelete}
                                    />
                                    <Buttons.ButtonWithIcon
                                        key={14}
                                        code={"excel"}
                                        icon={"images/buttons/icon-excelLogo.png"}
                                        selected={false}
                                        onClick={onExport}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td className={"lo-col"}>
                    <div
                        className={"cell-content-wrapper"}
                        style={
                            {
                                borderRight: "2px solid white",
                            }
                        }
                    >
                        <div className={"vertical-align"}>
                            {lo.toFixed(1)}°
                        </div>
                    </div>
                </td>
                <td className={"hi-col"}>
                    <div
                        className={"cell-content-wrapper"}
                        style={{
                            borderRight: (showExtremes) ? "none" : "2px solid gainsboro",
                            boxShadow: (showExtremes) ? null : "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                        }}
                    >
                        <div className={"vertical-align"}>
                            {hi.toFixed(1)}°
                        </div>
                    </div>
                </td>
                {showExtremes
                    ? (
                        <td className={"def-col"}>
                            <div
                                className={"cell-content-wrapper"}
                                style={{
                                    borderRight: "2px solid gainsboro",
                                    boxShadow: "6px 0px 6px 0px rgb(0 0 0 / 7%)",
                                }}
                            >
                                <div className={"vertical-align"}>
                                    <div className={"max-label"}>{max}</div>
                                    <div className={"avg-label"}>{avg}</div>
                                    <div className={"min-label"}>{min}</div>
                                </div>
                            </div>
                        </td>
                    ) : null
                }
                {
                    records.map((t, i) => {
                        return (
                            <HaccpTableCell
                                texts={texts}
                                showExtremes={showExtremes}
                                key={i}
                                record={t}
                                hour={i}
                            />
                        );
                    })
                }
            </tr>
        );
    }

    public static renderTemperatures = (records, texts:
                                            {
                                                lo: string, hi: string,
                                            },
                                        showExtremes, rowKey?) => {
        return (
            <tr className={"HaccpTableRow"} key={rowKey}>
                {
                    records.map((t, i) => {
                        return (
                            <HaccpTableCell texts={texts} showExtremes={showExtremes} key={i} record={t} hour={i}/>
                        );
                    })
                }
            </tr>
        );
    }
}
